customElements.define(
  'subscription-summary',
  class SubscriptionSummary extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "itemRemove": "[data-item-remove]",
        "itemRemoveData": "itemRemove",
        "summaryOverlay": "[data-summary-overlay]",
        "summaryHeader": "[data-summary-header]",
        "summaryHeaderPrice": "[data-summary-header-price]",
        "summaryHeaderCounter": "[data-summary-header-counter]",
        "summaryContent": "[data-summary-content]",
        "summaryClose": "[data-summary-close]",
        "continueShoppingAbonnement": "[data-continue-shopping-abonnement]",
        "dropdown": "#dropbox",
        "selectBox": "select.abonnement-summary__select-box",
        "selection": "#selected_title",
        "summaryEmpty": "[data-summary-empty]",
        "summaryNonEmpty": "[data-summary-non-empty]",
        "summaryLineItems": "[data-summary-line-items]",
        "summaryButtonAddToCart": "[data-summary-button-add-to-cart]",
        "summaryProgressBarMinimum": "[data-progress-bar-minimum]",
        "summaryProgressBarText": "[data-progress-bar-text]",
        "summaryProgressBar": "[data-progress-bar]",
      };

      this.selectors = selectors;

      this.summaryOverlay = this.querySelector(this.selectors.summaryOverlay);
      this.summaryHeader = this.querySelector(this.selectors.summaryHeader);
      this.summaryHeaderPrice = this.querySelector(this.selectors.summaryHeaderPrice);
      this.summaryHeaderCounter = this.querySelector(this.selectors.summaryHeaderCounter);
      this.summaryContent = this.querySelector(this.selectors.summaryContent);
      this.summaryClose = this.querySelector(this.selectors.summaryClose);
      this.continueShoppingAbonnement = this.querySelector(this.selectors.continueShoppingAbonnement);
      this.dropdown = this.querySelector(this.selectors.dropdown);
      this.selectBox = this.querySelector(this.selectors.selectBox);
      this.selection = this.querySelector(this.selectors.selection);
      this.summaryEmpty = this.querySelector(this.selectors.summaryEmpty);
      this.summaryNonEmpty = this.querySelector(this.selectors.summaryNonEmpty);
      this.summaryLineItems = this.querySelector(this.selectors.summaryLineItems);
      this.summaryButtonAddToCart = this.querySelector(this.selectors.summaryButtonAddToCart);
      this.summaryProgressBarMinimum = this.querySelector(this.selectors.summaryProgressBarMinimum);
      this.summaryProgressBarText = this.querySelector(this.selectors.summaryProgressBarText);
      this.summaryProgressBar = this.querySelector(this.selectors.summaryProgressBar);

      this.subcriptions = [];
      this.frequency = null;
      // this.initCookie();
      this.init();
      this.checkUrl();
      this.initFrequenciesSelect();
      
      var self = this;

      this.summaryButtonAddToCart.addEventListener('click', function(e){
        self.addToCart();
        // self.summaryButtonAddToCart.classList.add('loading');


      });

      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        this.summaryHeader.addEventListener('click', function(e){
          self.openSummaryMobile(e.target);
        });
        this.summaryOverlay.addEventListener('click', function(e){
          self.closeSummaryMobile();
        });
        this.summaryClose.addEventListener('click', function(e){
          self.closeSummaryMobile();
          let url = window.location.search;
          let urlParams = new URLSearchParams(url);
        });
        this.continueShoppingAbonnement.addEventListener('click', function(e){
          self.closeSummaryMobile();
          // setTimeout(() => {
          //   // document.getElementById("abonnement-tags__header").scrollIntoView();
          //   const id = 'abonnement-tags__header';
          //   const yOffset = -100; 
          //   const element = document.getElementById(id);
          //   const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          //   window.scrollTo({top: y, behavior: 'smooth'});
          // }, 1000);
        });
      }

      if (document.querySelectorAll('.abonnement-type-tags__container').length > 0) {
        document.querySelector('.abonnement-type-tags__container').addEventListener('change', function(){
          if (document.querySelectorAll('.abonnement-categorie:checked')) {
            var subscriptionCheckedTag = document.querySelector('.abonnement-categorie:checked');
            var subscriptionCheckedTagId = subscriptionCheckedTag.getAttribute('id');
            var subscriptionProducts = document.querySelectorAll('abonnement-product');
            for (let i = 0; i < subscriptionProducts.length; i++) {
              const product = subscriptionProducts[i];
              var product_tags = product.getAttribute('data-abonnement-product-tag');



              var product_tags_array = [];
              product_tags_array.push(product_tags.split(','));
              product_tags_array = product_tags_array.flat();
              
              console.log(product_tags_array.includes(subscriptionCheckedTagId))
              if (product_tags_array.includes(subscriptionCheckedTagId)) {
                product.classList.add('active');
                product.classList.remove('not-active');
              } else {
                product.classList.remove('active');
                product.classList.add('not-active');
              }
            }
          }
        })
      }

      if (document.querySelectorAll('.abonnement-product__accordion-button').length > 0) {


        var abonnementAccordion = document.querySelectorAll('.abonnement-product__accordions-container');
        for (let x = 0; x < abonnementAccordion.length; x++) {
          var abonnementProductQuestion = abonnementAccordion[x].querySelectorAll('.abonnement-product__accordion-button');
          for (let i = 0; i < abonnementProductQuestion.length; i++) {
            abonnementProductQuestion[i].addEventListener('click', function(){
              console.log(this);
              if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                if (abonnementAccordion[x].querySelectorAll('.abonnement-product__accordion-button.active').length > 0) {
                  if (abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active') != this) {
                    abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active').nextElementSibling.style.maxHeight = 0;
                    abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active').classList.remove('active');
                  }
                }
              }
              if (this.classList.contains('active')) {
                this.classList.remove('active');
                this.nextElementSibling.style.maxHeight = 0;
              } else {
                this.classList.add('active');
                this.nextElementSibling.style.maxHeight = (this.nextElementSibling.scrollHeight + 12) +  "px";
                this.nextElementSibling.style.height = (this.nextElementSibling.scrollHeight + 12) +  "px";
              }
            })
          }
      
        }
      
      }


      
    }

    checkUrl() {
      let url = window.location.search;
      let urlParams = new URLSearchParams(url);

      if(urlParams.has('type')) {
        var urlVariantType = urlParams.get('type');
        document.querySelectorAll('.abonnement-type').forEach((item) => {
          var tags = item.value.split(',');
          if (tags.includes(urlVariantType)) {
            if (!item.checked) {
              item.click();
            }
          } else {
            item.checked = false;
          }
        });
      }

      if(urlParams.has('categorie')) {
        var urlVariantCategorie = urlParams.get('categorie');
        document.querySelectorAll('.abonnement-categorie').forEach((item) => {
          var tags = item.value.split(',');
          if (tags.includes(urlVariantCategorie)) {
            if (!item.checked) {
              item.click();
            }
          } else {
            item.checked = false;
          }
        });
      }

      if(urlParams.has('variant')) {
        var urlVariantId = urlParams.get('variant');
        var urlVariantQuantity = urlParams.get('quantity');

        console.log('urlVariantId', urlVariantId);

        var urlVariantInput = document.querySelector('[data-product-variant-input][value="' + urlVariantId + '"]');
        var urlVariantProduct = document.querySelector('[data-product-variant-input][value="' + urlVariantId + '"]').parentElement.parentElement;
        urlVariantProduct.classList.add('has-border');
        urlVariantProduct.quantity = urlVariantQuantity;
        urlVariantProduct.querySelector('.abonnement-product__qty-nb').innerHTML = urlVariantQuantity;
        urlVariantInput.checked = true;
        urlVariantInput.nextElementSibling.classList.add('has-background');

        document.querySelector('subscription-summary').update(urlVariantId, urlVariantQuantity, {
          image: urlVariantInput.parentElement.parentElement.parentElement.querySelector('.abonnement-product__image').src,
          title: urlVariantInput.parentElement.parentElement.querySelector('.abonnement-product__title').innerHTML,
          variant_name: urlVariantInput.nextElementSibling.querySelector('span.option2').innerHTML,
          vendor: urlVariantInput.parentElement.parentElement.querySelector('.abonnement-product__vendor').innerHTML,
          unit_price: parseFloat(urlVariantInput.nextElementSibling.querySelector('span.price1').getAttribute('data-subscription-price-float').replace(',', '.')),
          unit_price_onetime: parseFloat(urlVariantInput.nextElementSibling.querySelector('span.price2').getAttribute('data-variant-price-float').replace(',', '.')),
          sellings_plan: JSON.parse(urlVariantInput.parentElement.parentElement.getAttribute("data-abonnement-product-selling-plans")).sellings_plan
        });

        // bug a regler
        document.querySelector('[data-summary-header-counter]').innerHTML = '(' + document.querySelector('[data-summary-header-counter]').innerHTML.replace('(', '').replace(')', '').replace(/^0+/, '') + ')';
        setTimeout(() => {
          document.querySelector('[data-summary-header]').click();
        }, 1000);

        window.addEventListener("DOMContentLoaded", (event) => {
        //   document.querySelectorAll('[data-abonnement-product-variants-id]').forEach((item) => {
        //     if (item.dataset.abonnementProductVariantsId.split(',').includes(urlVariantId)) {
        //       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        //         item.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
        //       } else {
        //         const className = '.abonnement-product.has-border';
        //         const yOffset = -100; 
        //         const element = document.querySelector(className);
        //         const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
  
        //         window.scrollTo({top: y, behavior: 'smooth'});
        //       }
              
        //     }
        //   });
        
        setTimeout(() => {
          const id = 'abonnement-tags__header';
          const yOffset = -100; 
          const element = document.getElementById(id);
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({top: y, behavior: 'smooth'});
        }, 1000);
        });


        
      }
    }

    init() {

      var self = this;
      this.itemRemoves = this.querySelectorAll(this.selectors.itemRemove); 
      this.itemRemoves.forEach((itemRemove) => {
        itemRemove.addEventListener('click', function(e){
          self.update(e.currentTarget.dataset[self.selectors.itemRemoveData], 0);
          console.log(e.currentTarget.dataset.itemRemove);
          console.log(document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]'))
          document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]').parentElement.parentElement.nextElementSibling.querySelector('[data-product-quantity]').innerHTML = "0";
          document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]').parentElement.parentElement.parentElement.quantity = 0;
          document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]').nextElementSibling.classList.remove('has-background');
          if (document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]').parentElement.querySelectorAll('label.has-background').length == 0) {
            document.querySelector('[data-product-variant-input][value="'+ e.currentTarget.dataset.itemRemove +'"]').parentElement.parentElement.classList.remove('has-border');
          }
        });
      });
      

    }

    // initCookie() {
    //   if (getCookie('subscriptionsCookie')) {
    //     this.subcriptions = JSON.parse(getCookie('subscriptionsCookie'));
    //     this.generateFront();
    //     console.log(getCookie('subscriptionsCookie'));
    //     setTimeout(() => {
    //       var activeProducts = document.querySelectorAll('abonnement-product.has-border');
    //       for (let i = 0; i < activeProducts.length; i++) {
    //         const element = activeProducts[i];
    //         element.querySelectorAll('.abonnement-product__variants-container label.has-background')[0].click();
    //       }
    //       if (document.querySelectorAll('.abonnement-summary__header.active').length > 0) {
    //         document.querySelector('.abonnement-summary__header.active').click();
    //       }
    //     }, 500);
    //   }
    // }

    update(variant_id, quantity, product_infos) {
      var subscriptionsContainsVariantID = false;
      var subscriptionIndex = null;
      for (let index = 0; index < this.subcriptions.length; index++) {
        if(variant_id == this.subcriptions[index].variant_id) {
          subscriptionsContainsVariantID = true;
          subscriptionIndex = index;
        }
      }

      if (subscriptionsContainsVariantID) {
        if (quantity == 0) {
          this.subcriptions.splice(subscriptionIndex, 1);
        } else {
          this.subcriptions[subscriptionIndex].quantity = quantity;
        }
      } else {
        var subscription = {
          "variant_id": variant_id,
          "quantity": quantity,
          "product_infos": product_infos
        };
        this.subcriptions.push(subscription);
      }

      console.log("this.subcriptions");
      console.log(this.subcriptions);

      this.generateFront();
      this.init();

      deleteCookie('subscriptionsCookie');
      setCookie('subscriptionsCookie', JSON.stringify(this.subcriptions), 5);
      
    }

    generateFront() {
      //mettre à jour les items
      //mettre le prix
      console.log('generateFront')
      

      if (this.subcriptions.length == 0) {
        this.summaryEmpty.classList.remove('hidden');
        this.summaryNonEmpty.classList.add('hidden');
        this.summaryHeader.classList.remove('active');
        this.summaryHeaderPrice.innerHTML = "";
        this.summaryHeaderCounter.innerHTML = "(0)";
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          // document.querySelector('[data-cart-toggle]').style.display = 'block';
        }
      } else {
        this.summaryEmpty.classList.add('hidden');
        this.summaryNonEmpty.classList.remove('hidden');
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          // document.querySelector('[data-cart-toggle]').style.display = 'none';
        }
        if (!this.summaryContent.classList.contains("active")) {
          this.summaryHeader.classList.add('active');
        }

        this.summaryLineItems.innerHTML = "";

        var all_quantities = 0;

        var all_prices = 0;
        var all_full_prices = 0;
        for (let index = 0; index < this.subcriptions.length; index++) {
          var subscription = this.subcriptions[index];
          console.log('subscription',subscription)
          all_quantities = Number(all_quantities) + Number(subscription.quantity);
          all_prices = all_prices + subscription.quantity * subscription.product_infos.unit_price;
          all_full_prices = all_full_prices + subscription.quantity * subscription.product_infos.unit_price_onetime;

          console.log('product_infos',subscription.product_infos)
          const markup = `
          <div class="line-item__content-wrapper abonnement-summary__line_item">
            <div class="line-item__image-wrapper">
              <img src="${subscription.product_infos.image}" class="line-item__image">
            </div>
            <div class="line-item__info">
              <div class="product-item-meta">
                <div class="abonnement-summary__line_item-title-span">${subscription.product_infos.title}</div>
                <!--<div class="abonnement-summary__line_item-variant">${subscription.product_infos.variant_name}</div>-->
                <div class="product-item-meta__price-list-container text--small">
                  <div class="hidden-tablet-and-up price-list">
                    <span class="price price--highlight">
                      ${(subscription.quantity * subscription.product_infos.unit_price).toFixed(2).replace('.', ',')}€
                    </span>
                    <span class="price price--compare">
                    ${(subscription.quantity * subscription.product_infos.unit_price_onetime).toFixed(2).replace('.', ',')}€
                    </span>
                  </div>
                </div>
              </div>
              <div class="abonnement-summary__line_item-quantity">Quantité : ${subscription.quantity}</div>
              <div class="abonnement-summary__line_item-remove hidden-tablet-and-up" data-item-remove="${subscription.variant_id}">Supprimer</div>
            </div>

            <div class="line-item__price-list-container abonnement-summary__line_item-remove-container text--small hidden-phone">
              <div class="price-list price-list--stack">
                <span class="price price--highlight">
                ${(subscription.quantity * subscription.product_infos.unit_price).toFixed(2).replace('.', ',')}€
                </span>
                <span class="price price--compare">
                ${(subscription.quantity * subscription.product_infos.unit_price_onetime).toFixed(2).replace('.', ',')}€
                </span>
              </div>
              <span class="abonnement-summary__line_item-remove hidden-phone" data-item-remove="${subscription.variant_id}">Supprimer</span>
            </div>
          </div>
          `;

          this.summaryLineItems.insertAdjacentHTML( 'beforeend', markup );          
        }

        if (document.querySelector('.abonnement-summary__progress-bar')) {
          this.updateProgressBar(all_prices);
        }

    
        this.summaryHeaderCounter.innerHTML = "(" + all_quantities + ")";
        console.log(all_prices);
        document.querySelector('.abonnement-summary__add_to_cart-price').innerHTML = (all_prices.toFixed(2).replace('.', ',') + '€');
        document.querySelector('[data-summary-header-price]').innerHTML = (all_prices.toFixed(2).replace('.', ',') + '€ | ');
        document.querySelector('.abonnement-summary__economy_price').innerHTML = ((all_full_prices - all_prices).toFixed(2).replace('.', ',') + '€');
      }
    }

    updateProgressBar(total_price) {
      var minimum_price = Number(this.summaryProgressBarMinimum.dataset.progressBarMinimum.replace(',', '.'));
      var text = this.summaryProgressBarText.dataset.progressBarText;
      var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

      console.log('total_price', total_price, typeof total_price);
      console.log('minimum_price', minimum_price, typeof minimum_price);
      console.log(total_price, minimum_price, minimum_price > total_price);

      if (minimum_price < total_price) {
        this.summaryProgressBarMinimum.classList.add("hidden");
        //this.summaryButtonAddToCart.classList.remove("disabled");
      } else {

        var price_remaining = (minimum_price - total_price).toFixed(2).replace('.', ',');
        this.summaryProgressBarText.innerHTML = text.replace('#LEFT#', price_remaining + '€');

        var percent = (total_price * 100) / minimum_price;
        this.summaryProgressBar.style.width = percent + '%';

        this.summaryProgressBarMinimum.classList.remove("hidden");
        //this.summaryButtonAddToCart.classList.add("disabled");
      }
    }

    async addToCart() {
      //loop sur this.subcriptions
      //ajouter au panier

      var items = [];

      for (let index = 0; index < this.subcriptions.length; index++) {
        var subscription = this.subcriptions[index];
        var selling_plan_id = null;

        /*for (let j = 0; j < this.subcriptions[index].product_infos.sellings_plan.length; j++) {
          const selling_plan = this.subcriptions[index].product_infos.sellings_plan[j];
          console.log(selling_plan)
          console.log(parseInt(this.frequency))
          if (parseInt(this.frequency) == selling_plan.frequency) {
            selling_plan_id = selling_plan.id;
          }
        }*/

        const plans = this.subcriptions[index].product_infos.sellings_plan;

// attention : this.frequency est en "1, 2, 3" → il faut -1 car tableau indexé à 0
        const planIndex = parseInt(this.frequency, 10) - 1;

        console.log('frequency', this.frequency)
        console.log('index', planIndex)
        console.log('plans', plans);

        if (plans[planIndex]) {
          selling_plan_id = plans[planIndex].id;
        } else {
          console.error(`Aucun selling plan trouvé pour frequency=${this.frequency}`);
        }

        console.log(selling_plan_id)

        items.push(
          {
            id: subscription.variant_id,
            quantity: subscription.quantity,
            selling_plan: selling_plan_id,
            title: subscription.product_infos.title,
            properties: {
              "_is_subscription": "true",
              "_shipping_interval_frequency": this.frequency,
              "_shipping_interval_unit_type": "Days"
            }
          }
        );
      }

      // comment to uncomment : 

      await this.removeOthersSubscriptions(this.frequency);

      console.log(items);
      

      // gtm

      // CartJS.addItems(items, {

          // var gtmProduct = [];
          // for (let i = 0; i < items.length; i++) {
          //   const element = items[i];
          //   console.log('element', element);

          //   var rightProduct = document.querySelector('abonnement-product[data-product-name="'+ element.title +'"]');
          //   console.log(rightProduct);
          //   gtmProduct.push({
          //       quantity : element.quantity.toString(),
          //       addToCartType : 'Ajout au panier d\'un abonnement',
          //       id : element.product_id,
          //       name : element.untranslated_product_title,
          //       price : rightProduct.getAttribute('data-product-price'),
          //       type : element.product_type,
          //       productType : 'Abonnement',
          //       // list:productList,
          //       espece: rightProduct.getAttribute('data-product-espece'),
          //       stock: rightProduct.getAttribute('data-product-stock'),
          //       discount: rightProduct.getAttribute('data-product-discount'),
          //   });
          //   console.log('gtmProduct', gtmProduct);
          // }

          let formData = {
            'items': items
          };

          console.log("Form: ", formData);

          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
          })
          .then( async (response) => {
    
            const responseJson = await response.json();
    
            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
              const cartContent = await response2.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent
                }
              }));
              cartContent["sections"] = responseJson["sections"];
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart: true
                }
              }));
            });
        })
        .catch((err) => {
            console.log("Error: ", err);
        });

      // this.summaryButtonAddToCart.classList.remove('loading');
    }

    removeOthersSubscriptions() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        try {
          var _cart = await (await fetch(`/cart.js`)).json();
          var subscriptions = {};
          subscriptions["updates"] = {};
    
          for (let i = 0; i < _cart.items.length; i++) {
            var element = _cart.items[i];
            if (element.properties != null && element.properties.hasOwnProperty('_shipping_interval_frequency')) {
              subscriptions["updates"][element.key] = 0;
            }
          }

          await self.updateItemById(subscriptions);
          
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }

    updateOthersSubscriptions(newFrequency) {
      var self = this;
      return new Promise(async (resolve, reject) => {
        try {
          var _cart = await (await fetch(`/cart.js`)).json();
          var subscriptions = [];
    
          for (let i = 0; i < _cart.items.length; i++) {
            var element = _cart.items[i];
            if (element.properties != null && element.properties.hasOwnProperty('_shipping_interval_frequency')) {
              subscriptions.push(
                {
                  "subscription_index": i + 1,
                  "subscription_key": element.key,
                  "subscription_variant_id": element.variant_id,
                  "subscription_handle": element.handle,
                  "subscription_quantity": element.quantity
                }
              );
            }
          }
    
          for (let index = 0; index < subscriptions.length; index++) {
            var handle = subscriptions[index].subscription_handle;
            var product = await this.getProduct(handle);

            var sellingPlans = product.selling_plan_groups[0].selling_plans;
            for (let j = 0; j < sellingPlans.length; j++) {
  
              if (sellingPlans[j].name.indexOf('Delivery every ' + newFrequency + ' Days') > -1) {
  
                console.log(sellingPlans[j].name, sellingPlans[j].id);
  
                var data = {
                  'properties': {
                    '_is_subscription': "true",
                    '_shipping_interval_frequency': newFrequency,
                    '_shipping_interval_unit_type': "Days"
                  },
                  'selling_plan': sellingPlans[j].id,
                  'line': subscriptions[index].subscription_index,
                  'quantity': subscriptions[index].subscription_quantity
                };

                console.log("product");
                await self.changeItemById(data);
                console.log(product.title);
  
              }
            }    
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }

    async getProduct(handle) {
      return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
      }).then(response => {
        return response.json();
      }).catch((error) => {
        console.error('Error:', error);
      });
    }

    async changeItem(data) {
      const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      });
    }
    
    changeItemById(data) {
      return this.changeItem(data);
    }

    async updateItem(data) {
      const result = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      });
    }
    
    updateItemById(data) {
      return this.updateItem(data);
    }
    

    openSummaryMobile(target) {
      target.classList.remove('active');
      target.nextElementSibling.classList.add('active');
      this.summaryOverlay.classList.add('active');
      this.summaryContent.style.maxHeight = this.summaryContent.scrollHeight +  "px";
    }

    closeSummaryMobile() {
      this.summaryContent.classList.remove('active');
      this.summaryOverlay.classList.remove('active');
      this.summaryContent.style.maxHeight = 0;
      if (this.subcriptions.length != 0) {
        this.summaryHeader.classList.add('active');
      }
    }

    dynamicListItemChanges(listItems, selectedItem) {
      for (let i = 0; i < listItems.children.length; i++) {
        let li = listItems.children.item(i);
        if (li) li.classList.remove('active');
      }
      selectedItem.classList.add('active');
    }

    initFrequenciesSelect() {
      if (this.dropdown != null) {
        const dropList = this.dropdown.querySelector('ul.abonnement-summary__list-items');

        document.addEventListener('click', e => {
          if (!this.dropdown.contains(e.target)) {
            if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
            }
          }
        });

        this.dropdown.addEventListener('click', e => {
          console.log("selected value: " + this.selectBox.value);
          if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
          } else {
              dropList.classList.add('open');
          }
          if (e.target.localName == 'li' && e.target.dataset.value) {
              console.log(e.target.dataset.value);
              this.selectBox.value = e.target.dataset.value;
              this.frequency = e.target.dataset.value;
              console.log(this.selectBox.value);
              this.selection.innerHTML = e.target.innerHTML;
              this.dynamicListItemChanges(dropList, e.target);
          }
        });
        document.querySelector('ul.abonnement-summary__list-items li').click();
        document.querySelector('ul.abonnement-summary__list-items li').click();
      }
    }


  }
);


// quantity selector
customElements.define(
  'abonnement-product',
  class AbonnementProduct extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "productMinusBtn": "[data-product-minus]",
        "productPlusBtn": "[data-product-plus]",
        "maximumAttribute" : 'data-product-maximum',
        "productQuantity": "[data-product-quantity]",
        "productVariantInput": "[data-product-variant-input]",
        "productSellingsPlan": "[data-abonnement-product-selling-plans]",
        "productSellingsPlanData": "abonnementProductSellingPlans",
      };

      this.selectors = selectors;

      this.productMinusBtn = this.querySelector(this.selectors.productMinusBtn);
      this.productPlusBtn = this.querySelector(this.selectors.productPlusBtn);
      this.productQuantity = this.querySelector(this.selectors.productQuantity);
      this.productVariantInputs = this.querySelectorAll(this.selectors.productVariantInput);

      this.quantity = 0;
      this.addedVariants = [];
      this.init();
    }

    init() {
      var self = this;

      this.productPlusBtn.addEventListener('click', function() {
        var selectedVariantId =  null;
        if (self.querySelector('.abonnement-product__variants-container input:checked') == null) {
          self.displayTooltipMessage(self.productPlusBtn);
        } else {
          var selectedVariantId = self.querySelector('.abonnement-product__variants-container input:checked').value;
          var selectedOption = self.querySelector('.abonnement-product__variants-container input:checked').dataset.productVariantName;
          var selectedImage = self.querySelector('.abonnement-product__image').src;
          var selectedTitle = self.querySelector('.abonnement-product__title').textContent;
          var selectedSubscriptionPrice = self.querySelector('.abonnement-product__variants-container input:checked').getAttribute('data-subscription-price-float');
          var selectedVariantPrice = self.querySelector('.abonnement-product__variants-container input:checked').getAttribute('data-variant-price-float');
          
          self.quantity = self.quantity + 1;
          self.productQuantity.innerHTML = self.quantity;

          if (self.quantity > 0) {
            self.querySelector('[data-product-minus]').classList.remove('product__qty-btn-disabled');
          }

          var selectedVariantInput = self.querySelector('.abonnement-product__variants-container input:checked');

          if (selectedVariantInput.hasAttribute('data-limited_order')) {
            var limit = selectedVariantInput.getAttribute('data-limited_order');
            if (self.quantity.toString() >= limit) {
              this.classList.add('product__qty-btn-disabled');
            }
          }

          if (!self.addedVariants.includes(selectedVariantId)) {
            self.addedVariants.push(selectedVariantId);
          }
          self.classList.add('has-border');
          document.querySelector('subscription-summary').update(selectedVariantId, self.quantity, {
            image: selectedImage,
            title: selectedTitle,
            variant_name: selectedOption,
            unit_price: parseFloat(selectedSubscriptionPrice.replace(',', '.').replace('€', '')),
            unit_price_onetime: parseFloat(selectedVariantPrice.replace(',', '.').replace('€', '')),
            sellings_plan: JSON.parse(self.dataset[self.selectors.productSellingsPlanData]).sellings_plan
          })
          console.log(self.quantity, selectedVariantId);
        }
      })

      this.productMinusBtn.addEventListener('click', function() {
        var selectedVariantId =  null;
        if (self.querySelector('.abonnement-product__variants-container input:checked') == null) {
          self.displayTooltipMessage(self.productMinusBtn);
        } else {
          var selectedVariantId = self.querySelector('.abonnement-product__variants-container input:checked').value;
          var selectedOption = self.querySelector('.abonnement-product__variants-container input:checked').dataset.productVariantName;
          var selectedImage = self.querySelector('.abonnement-product__image').src;
          var selectedTitle = self.querySelector('.abonnement-product__title').textContent;
          var selectedSubscriptionPrice = self.querySelector('.abonnement-product__variants-container input:checked').getAttribute('data-subscription-price-float');
          var selectedVariantPrice = self.querySelector('.abonnement-product__variants-container input:checked').getAttribute('data-variant-price-float');
                    
          var _quantity = self.quantity - 1;
          if (_quantity > -1) {
            self.quantity = self.quantity - 1;
            self.productQuantity.innerHTML = self.quantity;
            document.querySelector('subscription-summary').update(selectedVariantId, self.quantity, {
              image: selectedImage,
              title: selectedTitle,
              variant_name: selectedOption,
              unit_price: parseFloat(selectedSubscriptionPrice.replace(',', '.').replace('€', '')),
              unit_price_onetime: parseFloat(selectedVariantPrice.replace(',', '.').replace('€', '')),
              sellings_plan: JSON.parse(self.dataset[self.selectors.productSellingsPlanData]).sellings_plan
            });
            console.log(self.quantity, selectedVariantId);


            var selectedVariantInput = self.querySelector('.abonnement-product__variants-container input:checked');

            if (selectedVariantInput.hasAttribute('data-limited_order')) {
              var limit = selectedVariantInput.getAttribute('data-limited_order');
              if (self.quantity.toString() < limit) {
                this.parentElement.querySelector('[data-product-plus]').classList.remove('product__qty-btn-disabled');
              }
            }
          }
          if (self.addedVariants.includes(selectedVariantId)) {
            const index = self.addedVariants.indexOf(selectedVariantId);
            self.addedVariants.splice(index, 1);
          }
          if (self.quantity == 0) {
            self.querySelector('[data-product-minus]').classList.add('product__qty-btn-disabled');
          }
          if (self.addedVariants.length == 0 && self.querySelectorAll('.abonnement-product__variants-container label.has-background').length == 0 ) {
            self.classList.remove('has-border');
          }
        }
      })

      this.productVariantInputs.forEach((productVariantInput) => {
        productVariantInput.addEventListener('change', function(e) {
          var selectedTitle = self.querySelector('.abonnement-product__title').textContent;
          var selectedOption = self.querySelector('.abonnement-product__variants-container input:checked').dataset.productVariantName;
          var selectedSubscriptionPrice = self.querySelector('.abonnement-product__variants-container input:checked').dataset.subscriptionPriceFloat;
          var selectedPrice = self.querySelector('.abonnement-product__variants-container input:checked').dataset.variantPriceFloat;
          var abonnementSummaryItems = document.querySelector('subscription-summary').subcriptions;

          if (self.querySelector('.abonnement-product__variant-price-compare') != null) {
            self.querySelector('.abonnement-product__variant-price-compare').innerHTML = selectedPrice;
          }
          if (self.querySelector('.abonnement-product__variant-price') != null) {
            self.querySelector('.abonnement-product__variant-price').innerHTML = selectedSubscriptionPrice;
          }
          
          var findVariant = false;
          for (let i = 0; i < abonnementSummaryItems.length; i++) {
            const element = abonnementSummaryItems[i];
            const elementTitle = element.product_infos.title;
            const elementOption = element.product_infos.variant_name;
            const elementQuantity = element.quantity;
            if (selectedTitle.replace(/\s+/g, "") == elementTitle.replace(/\s+/g, "") && selectedOption == elementOption) {
              console.log('variant existe already', elementQuantity);
              self.quantity = elementQuantity;
              findVariant = true;
            }
          }
          if (!findVariant) {
            self.quantity = 0;
          }

          self.productQuantity.innerHTML = self.quantity;

          var selectedVariantInput = self.querySelector('.abonnement-product__variants-container input:checked');
          // console.log('hass', selectedVariantInput.hasAttribute('data-limited_order'));
          if (selectedVariantInput.hasAttribute('data-limited_order')) {
              var limit = selectedVariantInput.getAttribute('data-limited_order');
              if (self.quantity.toString() < limit) {
                self.querySelector('[data-product-plus]').classList.remove('product__qty-btn-disabled');
              } else {
                self.querySelector('[data-product-plus]').classList.add('product__qty-btn-disabled');
              }
          } else {
            self.querySelector('[data-product-plus]').classList.remove('product__qty-btn-disabled');
          }
        });
      });

    }

    displayTooltipMessage(element) {
      element.classList.add("show-tooltip");
      setTimeout(function () {
        element.classList.remove("show-tooltip");
      }, 2000);
    }

  }
);